var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.38,
    height: 76.24,
    viewBox: "0 0 55.785 57.18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1925,
    height: 1112
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1081
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1925,
    height: 1112
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1081
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1925,
    height: 1112
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1092
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 1921,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1491,-47)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1509.5 78.004c-1.6836 1.3008-3.3359 2.625-4.9726 3.9531l0.7617 1.9766c0.2812-0.23438 0.5586-0.46875 0.8359-0.69922 1.8867-1.543 3.8086-3.0508 5.7657-4.5234-0.7891-0.23828-1.586-0.47266-2.3907-0.70703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1503.3 78.926c0.793-0.66016 1.5859-1.3203 2.3867-1.957-0.539-0.14062-1.0781-0.28125-1.6211-0.41406h-0.01l0.039 0.01172c-0.4453 0.33594-0.8711 0.67578-1.3125 1.0156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1512.5 71.949c-0.074 0.04687-0.1446 0.10156-0.2188 0.15234 0.8633-0.59766 1.7383-1.1719 2.6172-1.75l-0.4336-1.1992c-1.1484 0.76562-2.2891 1.543-3.4141 2.3281 0.4844 0.15234 0.9688 0.30859 1.4493 0.46875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1502.6 77.016c0.2696-0.21094 0.5313-0.42188 0.8008-0.63281-0.3789-0.08984-0.7617-0.16797-1.1445-0.25391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1504.1 81.031c1.3867-1.125 2.7852-2.2422 4.207-3.3438-0.3945-0.11328-0.7929-0.22266-1.1914-0.32812 0.012 0.0039 0.02 0.0078 0.031 0.0078-1.1446 0.89844-2.2735 1.8242-3.3985 2.7539z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1522.6 71.191c5.9922-3.8828 12.242-7.3945 18.727-10.43l1.7617-4.4688c-6.2891 2.6328-12.414 5.6836-18.332 9.1406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1536.7 72.633 0.1914-0.48437c-1.6523 0.80859-3.2773 1.668-4.8555 2.6172 1.543-0.73828 3.0977-1.4453 4.6641-2.1328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530.3 83.043-0.2461 0.12109c-0.2265 0.12109-0.4531 0.24609-0.6757 0.36719l-0.055-0.01563-0.1368 0.06641 1.5938 0.50781c0.3906 0.16016 0.7695 0.34766 1.1562 0.51953l1.2422-3.1484c-0.9726 0.52344-1.9375 1.0469-2.8945 1.5742z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1517.2 79.734 1.2578 0.39062-0.3789-1.0508c-0.1015 0.07422-0.207 0.14453-0.3125 0.21875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1515 72.781c0.2071-0.14453 0.4219-0.28125 0.6328-0.42188l-0.3359-0.92969c-0.4726 0.32812-0.9531 0.64062-1.4219 0.97266 0.375 0.125 0.75 0.25 1.125 0.37891z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1512.5 73.383c-1.6016 1.1484-3.1836 2.3281-4.7383 3.5391 0.3945 0.09766 0.7851 0.19922 1.1797 0.30469 1.5781-1.2148 3.1836-2.4023 4.8125-3.5664-0.4141-0.09375-0.8321-0.18359-1.2539-0.27734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1538.3 68.609 1.043-2.6484c-6.6094 3.4141-12.965 7.3164-19.059 11.57l-0.8711 2.3203c5.5938-3.8906 11.426-7.4219 17.473-10.559 0.4726-0.23047 0.9414-0.45703 1.414-0.68359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1531.4 58.371c4.3281-2.2734 8.7656-4.3008 13.293-6.0898l2.0782-5.2812h-15.078l-5.2773 14.07c1.6484-0.92187 3.3086-1.8281 4.9844-2.6992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1512.8 64.328-6.2578-17.328h-15.496l5.3633 13.914c5.5195 0.83594 10.992 1.9844 16.391 3.4141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1522.7 81.934c-4.164 2.4102-8.2851 5.0781-12.387 7.8594-0.5625 0.81641-1.2344 1.543-1.9648 2.2109l0.5859 1.5195c4.6758-4.1133 9.418-8.0469 14.652-11.312-0.2968-0.08984-0.5898-0.18359-0.8867-0.27734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1528.6 83.945c-3.6758 2.0273-7.125 3.7266-10.621 5.8828-2.8047 1.7305-5.5039 3.75-8.1797 5.918l3.25 8.4336h11.207l7.4766-18.977c-1.0235-0.45703-2.0703-0.88281-3.1328-1.2578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1509.3 72.719v-0.0039c-1.5859 1.1328-3.1445 2.2773-4.6797 3.4375 0.5391 0.125 1.086 0.25781 1.6211 0.39453 1.6094-1.2617 3.2383-2.4688 4.8907-3.6445-0.074 0.05469-0.1446 0.10547-0.2188 0.15234-0.5351-0.10938-1.0742-0.22266-1.6172-0.33594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1500.3 71.055 1.7383 4.5117c0.6485 0.14062 1.293 0.27344 1.9375 0.42578 2.0274-1.5859 4.0938-3.1172 6.1875-4.6094-0.5429 0.38281-1.0781 0.76953-1.6133 1.1562-2.7265-0.55078-5.4843-1.0469-8.25-1.4844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1516.6 80.145-0.1836 0.07813c-2.3984 1.7617-4.7539 3.5703-7.0703 5.4258l-2.6367 2.1367 0.4961 1.2891c3.539-2.9414 7.2031-5.7695 11-8.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1515.3 74.027c-0.1055-0.02344-0.211-0.05078-0.3203-0.07422 0-0.0078 0.02-0.01563 0.027-0.01953l-0.035-0.0078c-1.6602 1.1797-3.3008 2.3867-4.9141 3.6211 0.8164 0.23047 1.625 0.46875 2.4297 0.71484 1.3828-1.0352 2.7851-2.0469 4.1953-3.043l-0.3359-0.93359c-0.3516-0.0625-0.7032-0.14844-1.0469-0.25781z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1499.2 68.258c3.7852 0.83203 7.5156 1.8438 11.141 2.9766 1.2969-0.92188 2.6094-1.8242 3.9297-2.707l-0.7617-2.1133c-5.3633-1.0117-10.637-1.8594-15.957-2.4219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1531.7 59.164c-1.9024 0.9375-3.7813 1.9258-5.6406 2.9492l-0.7696 2.0508c0.7813-0.42969 1.5586-0.85547 2.3516-1.2773 5.1562-2.5703 10.406-4.9922 15.738-7.1914l0.8945-2.2695c-4.25 1.668-8.4492 3.5664-12.574 5.7383z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06b03a06cd306163e914b6943467c6fd.svg";
export { ForwardRef as ReactComponent };